angular.module('rjmNg.api').factory('Charts', [
  "$rootScope"
  "$routeParams"
  "$resource"
  "phpServiceUrl"
  "$cacheFactory"
  "$q"
  "$http"
  "app"
  ($rootScope, $routeParams, $resource, phpServiceUrl, $cacheFactory, $q, $http, app) ->
    chartCache = $cacheFactory "chartCache",
      number: 50

    getChartUrl = ->
      phpServiceUrl("/client/#{app.getClientId()}/chart/")

    getCacheParams = () ->
      cacheParams = {}
      if $routeParams.ccacheoff is "1"
        cacheParams.ccacheoff = true
      if $routeParams.qcacheoff is "1"
        cacheParams.qcacheoff = true
      if $routeParams.ccommitoff is "1"
        cacheParams.ccommitoff = true
      if $routeParams.timeoutoff is "1"
        cacheParams.timeoutoff = true
      if $routeParams.redshifton is "1"
        cacheParams.redshifton = true

      return cacheParams

    getChartsDeferredPromise = null
    getChartDataDeferredPromiseMap = {}
    getCharts: (forceGet = false) ->
      deferred = $q.defer()

      # if a promise exists making a call to the backend just return it
      # so the callee can then it
      if getChartsDeferredPromise?
        return getChartsDeferredPromise
      #check if we have the charts in the cache
      charts = chartCache.get(getChartUrl())
      if not forceGet and charts?
        deferred.resolve(charts)
        return deferred.promise
      #if we don't have a charts array in the cache create it
      unless charts?
        #when we upgrade to 1.2 these calls can be done in one line
        chartCache.put(getChartUrl(), [])
        charts = chartCache.get(getChartUrl())

      $http
        method: "GET"
        url: getChartUrl()
      .then (successResponse) ->
        angular.extend charts, successResponse.data
        deferred.resolve(charts)
        getChartsDeferredPromise = null
      , (errorResponse) ->
        deferred.reject(errorResponse)
        getChartsDeferredPromise = null

      return getChartsDeferredPromise = deferred.promise

    getChartData: (chartId, forceGet = false, timeout = null, getStale = false, doRecache = true) ->
      deferred = $q.defer()

      # if a promise exists making a call to the backend just return it
      # so the callee can then it
      if getChartDataDeferredPromiseMap[chartId]? and not forceGet
        return getChartDataDeferredPromiseMap[chartId]

      #check the cache for the data
      chartData = chartCache.get chartId
      if not forceGet and chartData?.id?
        deferred.resolve(chartData)
        return deferred.promise
      #if there is no chartData in the cache create and add it to the cache
      unless chartData?.id?
        chartCache.put(chartId, {})
        chartData = chartCache.get(chartId)

      params =
        angular.extend(getCacheParams(),
          getstale: +getStale
          recache: +doRecache
        )

      #get it from the backend
      $http
        method: 'GET'
        url: getChartUrl() + chartId
        params: params
        timeout: timeout
      .then (successResponse) ->
        angular.extend chartData, successResponse.data
        deferred.resolve(chartData)
        delete getChartDataDeferredPromiseMap[chartId]
      , (errorResponse) ->
        deferred.reject errorResponse
        delete getChartDataDeferredPromiseMap[chartId]

      return getChartDataDeferredPromiseMap[chartId] = deferred.promise

    save: (chart, success, error) ->
      deferred = $q.defer()
      $http
        method: 'POST'
        url: getChartUrl() + chart.id
        data:
          chart
      .then (successResponse) =>
        #we don't do any copying here because it's handled in getChartData()
        @getCharts(true) #repopulate the chart list in case there was a name change
        @getChartData(chart.id, true)
        deferred.resolve(chartCache.get chart.id)
      , (errorResponse) ->
        deferred.reject(errorResponse)

      return deferred.promise

    saveAs: (chart, name, userId, dashboardId, success, error) ->
      deferred = $q.defer()
      newChart = {}; #create an object to be saved to add to the cache and hold our data for later

      $http
        method: 'POST'
        url: getChartUrl() + "#{chart.id}/saveas/"
        data:
          name: name
          did: dashboardId
      .then (successResponse) =>
        #extend some of the properties of the old chart to the new chart
        #since the properties we are copying are not nested we can be confident
        #that we are not moving references around
        angular.extend newChart, chart
        #update new properties
        newChart.id = successResponse.data.id
        newChart.name = name
        newChart.userId = userId
        newChart.figureId = successResponse.data.figureId
        newChart.isCompositeInput = false
        #add the newChart to the cache
        chartCache.put newChart.id, newChart
        #if we are on the dashboard this chart was added to load it and fire off an event
        if dashboardId is $routeParams.dashId
          @getChartData(newChart.id, true)
          @chartAdded(successResponse.data.dcid)
        else # refresh the chart list
          @getCharts(true)

        deferred.resolve newChart
      , (errorResponse) ->
        deferred.reject errorResponse

      return deferred.promise

    chartSaved: (dcid) ->
      @getCharts(true)
      $rootScope.$broadcast('chartOrFigureSaved', {dcid: dcid})

    chartAdded: (dcid) ->
      @getCharts(true)
      $rootScope.$broadcast('chartOrFigureAdded', {dcid: dcid})

    clearCache: ->
      chartCache.removeAll()
  ]
)
